export const SOCIAL_ICON_DEFINITIONS = {
  facebook: {
    viewBox: "0 0 24 24",
    paths: [
      "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z",
    ],
  },
  instagram: {
    viewBox: "0 0 24 24",
    paths: [
      "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z",
    ],
  },
  twitter: {
    viewBox: "0 0 24 24",
    paths: [
      "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
    ],
  },
  linkedin: {
    viewBox: "0 0 24 24",
    paths: [
      "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
    ],
  },
  youtube: {
    viewBox: "0 0 24 24",
    paths: [
      "M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
    ],
  },
  tiktok: {
    viewBox: "0 0 24 24",
    paths: [
      "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z",
    ],
  },
  pinterest: {
    viewBox: "0 0 24 24",
    paths: [
      "M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 0 12.017 0z",
    ],
  },
  snapchat: {
    viewBox: "0 0 24 24",
    paths: [
      "M12.166.053C6.851.053 4.509 3.66 4.509 7.29v2.86c0 .394-.252.594-.67.788-.384.18-1.166.301-1.715.598-.377.203-.66.513-.66.93 0 .65.685 1.003 1.423 1.136.845.152 1.703.226 1.937.703.147.3.012.688-.137 1.063l-.008.02c-.522 1.266-1.595 3.01-3.165 3.903-.32.183-.602.475-.602.873 0 .33.19.614.436.812.605.49 1.503.683 2.333.812.543.084.98.337 1.132.904.07.259.102.568.359.82.274.268.69.308 1.072.308.487 0 1.068-.178 1.717-.406.882-.31 1.862-.648 3.12-.648 1.205 0 2.076.322 2.934.622.613.214 1.207.42 1.704.42.413 0 .757-.097.979-.359.194-.229.267-.504.32-.73.141-.578.591-.832 1.14-.918.83-.13 1.729-.323 2.333-.812.246-.198.436-.482.436-.812 0-.398-.282-.69-.602-.873-1.57-.893-2.643-2.637-3.165-3.902l-.008-.02c-.15-.377-.284-.763-.137-1.063.234-.477 1.092-.551 1.937-.703.738-.133 1.423-.487 1.423-1.136 0-.417-.283-.727-.66-.93-.549-.297-1.331-.418-1.715-.598-.418-.194-.67-.394-.67-.788V7.29C19.491 3.66 17.15.053 12.166.053z",
    ],
  },
  email: {
    viewBox: "0 0 24 24",
    paths: [
      "M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z",
      "M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z",
    ],
  },
  custom: {
    viewBox: "0 0 24 24",
    paths: [
      "M4.25203 10C4.08751 10.6392 4 11.3094 4 12C4 12.6906 4.08751 13.3608 4.25204 14H8.10516C8.03772 13.3727 8 12.7062 8 12C8 11.2938 8.03772 10.6273 8.10516 10H4.25203ZM5.07026 8H8.44148C8.74649 6.6871 9.17396 5.60504 9.60763 4.74755C9.68837 4.58792 9.76925 4.4362 9.8495 4.29235C7.81403 4.85906 6.10548 6.21041 5.07026 8ZM12 4.60481C11.8126 4.88536 11.6032 5.23336 11.3924 5.65018C11.0768 6.27421 10.7565 7.0555 10.5029 8H13.4971C13.2435 7.0555 12.9232 6.27421 12.6076 5.65018C12.3968 5.23336 12.1874 4.88536 12 4.60481ZM13.8818 10H10.1182C10.0431 10.6184 10 11.2848 10 12C10 12.7152 10.0431 13.3816 10.1182 14H13.8818C13.9569 13.3816 14 12.7152 14 12C14 11.2848 13.9569 10.6273 13.8818 10ZM15.8948 14C15.9623 13.3727 16 12.7062 16 12C16 11.2938 15.9623 10.6273 15.8948 10H19.748C19.9125 10.6392 20 11.3094 20 12C20 12.6906 19.9125 13.3608 19.748 14H15.8948ZM13.4971 16H10.5029C10.7565 16.9445 11.0768 17.7258 11.3924 18.3498C11.6032 18.7666 11.8126 19.1146 12 19.3952C12.1874 19.1146 12.3968 18.7666 12.6076 18.3498C12.9232 17.7258 13.2435 16.9445 13.4971 16ZM9.84951 19.7077C9.76925 19.5638 9.68837 19.4121 9.60763 19.2524C9.17396 18.395 8.74649 17.3129 8.44148 16H5.07026C6.10548 17.7896 7.81403 19.1409 9.84951 19.7077ZM14.1505 19.7076C14.2308 19.5638 14.3116 19.4121 14.3924 19.2524C14.826 18.395 15.2535 17.3129 15.5585 16H18.9297C17.8945 17.7896 16.186 19.1409 14.1505 19.7076ZM18.9297 8H15.5585C15.2535 6.6871 14.826 5.60504 14.3924 4.74755C14.3116 4.58792 14.2308 4.4362 14.1505 4.29235C16.186 4.85906 17.8945 6.21041 18.9297 8ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
    ],
  },
};

const DEFAULT_ICON_COLOR = "#111827";
const DEFAULT_ICON_SIZE = 32;
const EMAIL_ICON_SCALE = 2;

export const normalizeSocialIconColor = (color) => {
  const value = String(color || "").trim();
  return /^#[0-9a-f]{3,8}$/i.test(value) ? value : DEFAULT_ICON_COLOR;
};

export const normalizeSocialIconSize = (size) => {
  const value = parseInt(size, 10);
  return Number.isFinite(value) && value > 0 ? value : DEFAULT_ICON_SIZE;
};

export const createSocialIconSvgMarkup = (platform, color) => {
  const definition = SOCIAL_ICON_DEFINITIONS[platform] || SOCIAL_ICON_DEFINITIONS.custom;
  const iconColor = normalizeSocialIconColor(color);
  const paths = definition.paths.map((path) => `<path d="${path}"/>`).join("");
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${definition.viewBox}" fill="${iconColor}">${paths}</svg>`;
};

export const rasterizeSocialIconToPng = (platform, color, size) => new Promise((resolve, reject) => {
  if (typeof document === "undefined" || typeof Image === "undefined") {
    reject(new Error("Social icon PNG generation requires a browser"));
    return;
  }

  const displaySize = normalizeSocialIconSize(size);
  const pixelSize = displaySize * EMAIL_ICON_SCALE;
  const svg = createSocialIconSvgMarkup(platform, color);
  const blobUrl = URL.createObjectURL(new Blob([svg], { type: "image/svg+xml;charset=utf-8" }));
  const image = new Image();

  const cleanup = () => URL.revokeObjectURL(blobUrl);
  image.onload = () => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = pixelSize;
      canvas.height = pixelSize;
      const context = canvas.getContext("2d");
      if (!context) throw new Error("Canvas is unavailable");
      context.clearRect(0, 0, pixelSize, pixelSize);
      context.drawImage(image, 0, 0, pixelSize, pixelSize);
      const pngDataUri = canvas.toDataURL("image/png");
      cleanup();
      resolve(pngDataUri);
    } catch (error) {
      cleanup();
      reject(error);
    }
  };
  image.onerror = () => {
    cleanup();
    reject(new Error(`Failed to rasterize the ${platform || "custom"} social icon`));
  };
  image.src = blobUrl;
});

const isUploadedCustomIcon = (item) => (
  item?.iconMode === "upload" && Boolean(item?.customIconSrc)
);

export const prepareScratchSocialIconsForEmail = async (
  blocks,
  rasterize = rasterizeSocialIconToPng,
) => {
  const generatedBySignature = new Map();

  const prepareItem = async (item, block) => {
    const nextItem = { ...item };
    if (nextItem.type !== "icon") return nextItem;

    if (isUploadedCustomIcon(nextItem)) {
      delete nextItem.emailIconSrc;
      delete nextItem.emailIconPlatform;
      delete nextItem.emailIconColor;
      delete nextItem.emailIconSize;
      return nextItem;
    }

    const platform = SOCIAL_ICON_DEFINITIONS[nextItem.platform] ? nextItem.platform : "custom";
    const color = normalizeSocialIconColor(block?.iconColor);
    const size = normalizeSocialIconSize(block?.iconSize);
    const signature = `${platform}:${color.toLowerCase()}:${size}`;
    const existingMatches = (
      nextItem.emailIconSrc
      && nextItem.emailIconPlatform === platform
      && String(nextItem.emailIconColor || "").toLowerCase() === color.toLowerCase()
      && Number(nextItem.emailIconSize) === size
    );

    if (existingMatches) {
      generatedBySignature.set(signature, nextItem.emailIconSrc);
    } else {
      let generatedSource = generatedBySignature.get(signature);
      if (!generatedSource) {
        generatedSource = rasterize(platform, color, size);
        generatedBySignature.set(signature, generatedSource);
      }
      nextItem.emailIconSrc = await generatedSource;
      generatedBySignature.set(signature, nextItem.emailIconSrc);
    }

    nextItem.emailIconPlatform = platform;
    nextItem.emailIconColor = color;
    nextItem.emailIconSize = size;
    return nextItem;
  };

  const prepareBlock = async (block) => {
    const nextBlock = { ...block };
    if (nextBlock.type === "social") {
      nextBlock.items = await Promise.all((nextBlock.items || []).map((item) => prepareItem(item, nextBlock)));
    }
    if (nextBlock.type === "columns") {
      nextBlock.columns = await Promise.all((nextBlock.columns || []).map(async (column) => ({
        ...column,
        blocks: await Promise.all((column.blocks || []).map(prepareBlock)),
      })));
    }
    return nextBlock;
  };

  return Promise.all((blocks || []).map(prepareBlock));
};

export const getSocialIconEmailSrc = (item) => {
  if (isUploadedCustomIcon(item)) return item.customIconSrc;
  return item?.emailIconSrc || "";
};
